/**
 * 使用Switch开关作为折叠按钮
 * 当不传递children时, 就只是一个 开关按钮
 */
import React, {memo, useState} from 'react';
import {Switch} from 'tea-component';
import classNames from "classnames";
import CustomJustify from "@/pages/datalab/components/CustomJustify";
import './index.scss';

const SwitchCollapse = (props: any) => {
  const { title, className, defaultOpen = false, onOpenChange, children} = props;
  const [open, setOpen] = useState(defaultOpen);
  
  return (<div className={classNames("dbl-switch-collapse", className)}>
    <CustomJustify
      className="dbl-switch-collapse__header"
      left={title}
      right={(<Switch
        value={open}
        onChange={(value) => {
          setOpen(value);
          onOpenChange?.(value);
        }}
      />)}
    />
    
    {
      children ? <div className={classNames("dbl-switch-collapse__body", {'dbl-switch-collapse__body--open': open})}>
        {children}
      </div> : ''
    }
  </div>);
};


export default memo(SwitchCollapse);